import {CloudName, CloudType, Environment} from '@q9elements/ui-kit/common';

export const environment: Environment = {
    production: true,
    CLOUD_TYPE: CloudType.PUBLIC,
    CLOUD_NAME: CloudName.ELEMENTS, 
    ENV: 'loadtest',      
    version: require('../../package.json').version,
    MAIN_APP_URL: 'https://loadtest-app.q9elements.com',
    API_STATIC_FILE_UPLOAD: 'https://loadtest-upload.q9elements.com:1443/api',
    CHANGELOG_APP_URL: 'https://loadtest-changelogs.q9elements.com',
    API_ENDPOINT: 'https://loadtest-api.q9elements.com/api/v1', 
    REMOTE_UNLOCK_TTL: 600000,
    TEAM_APP: 'https://loadtest-spacemgt.q9elements.com',
    RELEASE_URL: 'https://loadtest-releasemgt.q9elements.com',
    REPORTS_API_ENDPOINT: 'https://loadtest-gateway.q9elements.com/report/api/v1',
    REF_MODEL_APP: 'https://loadtest-refmodel.q9elements.com',
    REPORTS_APP: 'https://loadtest-report.q9elements.com',
    MAP_MANAGEMENT_APP: 'https://loadtest-mapmgt.q9elements.com',
    INTERCOM_APP_ID: 'sfi4u1en',
    DOMAIN: 'q9elements.com',
    SECURE_COOKIES: true,
    SENTRY_AUTH_TOKEN: '',
    SENTRY_DSN: '',
    SENTRY_ORG: '',
    SENTRY_PROJECT: 'diagram-app',
    DIAGRAM_URL: 'https://loadtest-diagram.q9elements.com',
    NOUI: false,
    DATA_STRUCTURE_URL: 'https://loadtest-datatable.q9elements.com',
    SALESFORCE_CLIENT_ID: '3MVG9Rd3qC6oMalVszZtK2Usdv9bqy4_doe6P1BuqzckkUu1t0JC1aW.e13T.i_8rQ3P8A9goskWvf4iLeabN',
    STATIC_FILES_URL: 'https://static.elements-eng.cloud',
    JAM_TEAM_ID: '',
    MCP_OAUTH_URL: 'https://loadtest-api.q9elements.com/api/v1/oauth',
    fbConfig: {
        apiKey:'AIzaSyC1scjCnEIl0p3hNSXPd7xv0gZInlcwr6M',
        authDomain:'elements-loadtest.firebaseapp.com',
        databaseURL: 'https://elements-loadtest-default-rtdb.firebaseio.com/',
        projectId: 'elements-loadtest',
        appId: '1:201990050997:web:3b9c59c614dcc81aea1afc'
    }
};
